enum AffectedArche {
  'UPPER' = 'UPPER',
  'LOWER' = 'LOWER',
  'BOTH' = 'BOTH',
}

export { AffectedArche }
